export default {
  page_header: {
    title: "За",
    description: "На оваа страница можете да најдете информации за системот Iris и неговите компоненти.",
  },

  // Tabs
  tabs: {
    overview_tab: {
      name: "Преглед",
      title: "Добредојдовте во Iris",
      subtitle: "Систем за поврзување на лаборатории и управување со примероци.",
      version_label: "Верзија на апликацијата",
      version_tooltip: "Тековна верзија на Iris UI",
      description:
        "Iris е веб-платформа за лабораториска поврзаност што ги поврзува клинички анализатори со лабораториски информациски системи (LIS). Управува канали за апарати, ги обработува резултатните податоци и ги насочува примероците низ работен тек за валидација пред публикување.",

      metadata: {
        publisher: "Издавач",
        publisher_tooltip: "Софтверски издавач одговорен за Iris",
        license: "Лиценца",
        license_tooltip: "Услови за дистрибуција на апликацијата",
        license_value: "Proprietary",
        stack: "Технологии",
        stack_tooltip: "Основни фронтенд технологии кои ја погонуваат Iris",
        stack_value: "Vue 3 / Nuxt 4 / Vuetify 3",
        publisher_value: "SKYWARE Group",
      },

      features: {
        header: "Клучни функции:",

        sample_management: {
          title: "Управување со примероци",
          subtitle: "Насочува резултати од апарати низ настроив тек за валидација пред публикување во LIS",
        },
        real_time_results: {
          title: "Резултати во реално време",
          subtitle: "Примање и прикажување на податоци од апарати преку TCP канали во моментот на пристигнување",
        },
        multilingual_support: {
          title: "Мултијазична поддршка",
          subtitle: "Префрлување помеѓу англиски, бугарски и македонски од секоја страница",
        },
        secure_authentication: {
          title: "Безбедна автентикација",
          subtitle: "Управување на пристап по улоги преку OIDC / Keycloak",
        },
        responsive_design: {
          title: "Респонзивен дизајн",
          subtitle: "Оптимизиран за десктоп, таблет и мобилни пребарувачи",
        },
        accessibility: {
          title: "Достапност",
          subtitle: "Согласно со WCAG 2.1 AA стандарди",
        },
        high_performance: {
          title: "Високи перформанси",
          subtitle: "Реактивен интерфејс создаден за временски осетливи лабораториски работни текови",
        },
      },

      targetUsers: {
        header: "За кого е Iris:",

        lab_technicians: {
          title: "Лабораториски техничари",
          subtitle:
            "Примаат резултати од апарати, ги прегледуваат примероците на чекање и ги одобруваат или одбиваат пред публикување во LIS",
        },
        pathologists: {
          title: "Патолози и специјалисти",
          subtitle: "Преглед и валидација на резултати од примероци во поврзаните апарати",
        },
        lab_administrators: {
          title: "Администратори на лаборатории",
          subtitle: "Конфигурираат апарати, канали и панели и ја следат работоспособноста на системот",
        },
      },
    },

    services_tab: {
      name: "Сервиси",
      title: "Системски сервиси",
      subtitle: "Верзија и здравствен статус за секој Iris сервис",

      refresh_button: "Освежување на сервиси",
      refresh_service: "Освежување",

      fe_description:
        "Веб интерфејсот. Го обезбедува корисничкиот интерфејс за управување со апарати, канали и работни текови за валидација на примероци.",
      core_description:
        "Централниот бекенд сервис. Управува со апарати, канали, тестови и редицата за валидација на примероци. Изложува REST API кој го конзумира Iris UI.",
      adapter_description:
        "Сервисот за LIS интеграција. Ги презема податоците за пациенти и нарачувања од LIS и ги публикува валидираните резултати назад во LIS.",
    },

    actions_tab: {
      name: "Акции",
      title: "Системски акции",
      subtitle: "Управување со кеш и конфигурација на системот",

      cache_card: {
        title: "Освежување на кешот на Iris Core",
        content:
          "Го избришува оперативниот кеш на Iris Core и го принудува преземањето на сите податоци од базата на податоци. Користете го за да решите застарени податоци по директни промени во базата на податоци.",
        action: "Освежување на кеш",
      },
    },

    copyright_tab: {
      name: "Авторски права",
      title: "Авторски права",
      subtitle: "Интелектуална сопственост и лиценци",

      description_start: "Сите права на интелектуална сопственост на оваа апликација им припаѓаат на ",
      description_end:
        ". Правата врз компонентите и библиотеките користени во оваа апликација им припаѓаат на нивните автори и се соодветно лиценцирани, како што е опишано подолу.",

      authors_label: "Автори на оваа апликација",
      authors_value: "Михаил Калачев, Иван Калачев",
      developed_by: "Развиен од",
      third_party_header: "Лиценци на трети страни",
      col_component: "Компонента",
      col_license: "Лиценца",
      col_author: "Автор",
    },

    credits_tab: {
      name: "Заслуги",
      title: "Заслуги",
      subtitle: "Изградено со технологии со отворен код",

      application_title: "Iris UI",
      authors_of_application: "Автори на оваа апликација",
      licence: "лиценца",
      et_al: "и др",
    },
  },
};
